import Http from "../util/httpUtils"
import { LOCATION_API } from "../constants/conf"

var URL = LOCATION_API + "/chain"

export default {
  customerInfo: function() {
    return new Promise((resolve, reject) => {
      Http.get(URL + "/customers/one")
        .then(res => {
          let data = res.data || {}
          resolve(data)
        })
        .catch(e => {
          resolve({})
        })
    })
  },
}
